module.exports = __webpack_public_path__ + "images/smartphone-screen-4_a48a53b9d12a017f1c54f4a9acc9bb80.png";